import { Injectable } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  redirectUrl = null;
  currentUrl = '';
  hideSplitPane = false;
  routerOutlet: IonRouterOutlet;
  constructor() { }
  canShowSplit() {
    return !this.hideSplitPane;
  }
}
